//REV_GEOCODE_URL: 'https://api.opencagedata.com/geocode/v1/json',
const PROP = {
  // BLANK_LINK: "#!",


  // BASE_URL: 'https://mosdac.gov.in', //Development
  BASE_URL: '', //Production

/********************* 
  Sat Imagery Section
*********************/
  URL_FCGALLERY: '/gallery/index.html?ds=weather',
  URL_STATEGALLERY: '/gallery/index.html?&prod=3DIMG_%2A_L1C_ASIA_MER_BIMG',
  GALLERY_SUFFIX: '_V*.jpg',

/********************* 
    API Section
*********************/
  API_BASEURL: 'https://api.mosdac.gov.in',
  // API_SWHURL: 'https://mosdac.gov.in',
  KEYHEADER: true,
  //1. APIAlert
  APIALERT_KEY: '3d910d02-f1e6-451e-b29f-0fc0d48b2e92',
  URL_STATEALERT: '/apis/apialert/v1/statealerts',
  URL_GJSONALERT: '/apis/apialert/v1/statejson',
  URL_STATUSALERT: '/apis/apialert/v1/status',
  URL_COUNTRYALERT: '/apis/apialert/v1/countryalerts',
  URL_COUNTRYGJSONALERT: '/apis/apialert/v1/countryjson',
  URL_COUNTRYSTATUSALERT: '/apis/apialert/v1/countrystatus',

  //2. APIWeather
  APIWEATHER_KEY: '4a8d3b6c-cc8a-489d-bb26-ef0c47967eb2',
  URL_WEATHER: '/apis/apiweather/weather',
  
  APIDATA_KEY: 'cf51868c-235d-4a73-9e3f-3b7eeca870df',
  URL_SWH: '/apis/apidata/swh',
  URL_SWH_NRT:'/apis/apidata/swhNRT',
  URL_SWH_PRJ:'/apis/apidata/swhPRJ',
  // URL_SLA: '/apis/apiweather/sla',
  URL_SLA: '/apis/apidata/sla',
  URL_SLA_NRT:'/apis/apidata/slaNRT',

  URL_WRF:'/apis/apidata/wrf',
  URL_CMIP6:'/apis/apidata/CMIP',
  //3. FreeAPIs
  URL_TEPHI: '/tephicity?time=',
  MET_URL_PREFIX: '/look/WRF/meteogram/WRF_METEOGRAM_',

/********************* 
    Info Section
*********************/
  PAGE_TITLE: 'FIPIC Portal',
  // MODEL_TITTLE: 'MOSDAC Information Services',
  MODEL_TITTLE: 'Extreme Weather Events: Space Based Monitoring and Climate impact',
  // SIDEDRAWER_TITTLE: 'State Selection',

  /***** Types *****/
  TYPES: {
    'WRF': '/apiweather1/weather?type=WRF',
    'GFS': '/apiweather1/weather?type=GFS'
  },

  DEFAULT_STATE: 'india',
};

export default PROP;